export async function loadColorUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("color", async (container) => {
        const { ColorUpdater } = await import("./ColorUpdater.js");
        return new ColorUpdater(container);
    }, refresh);
}
